import "./Home.css";
import "apexcharts/dist/apexcharts.css";
import Card from '../../components/card/Card';
import CardV2 from '../../components/card/CardV2';
import CardV3 from '../../components/card/CardV3';

export default function Home() {
    const currentYear = new Date().getFullYear();

    const scrollToTop = () => {
	    window.scrollTo(0, 0)
	};

    return (
        <div className="row">
            {/* Info da inserire */}
            <Card year={currentYear} />
            <CardV2 year={currentYear} />
            <CardV3 year={currentYear} />
        </div>
  );
}